<app-dialog
    class="upload-progress text-text-dark text-center"
    [header]="title">
    <app-progress-bar [progressValue]="(progress$ | async) ?? 0"></app-progress-bar>
    <div class="text-center">{{ (progress$ | async) ?? 0 }}%</div>
</app-dialog>
